export default __webpack_public_path__ + "static/media/loading.dc0e87c3.gif";